import store from "../store/store";
import {startEditing, stopEditing} from "../store/actions/savedStatusActions";

export type TopLevelProps = Partial<{
    topLevel: string;
    topLevelId: string;
}>;

export type PageEditingRef = TopLevelProps & {
    props?: TopLevelProps & {
        env?: TopLevelProps,
    },
    state?: {
        current?: {
            id: string,
        },
    },
}

export type PageEditingCurrentRef = {
    id?: string,
}

function parse(selfRef: PageEditingRef, page: string, current?: PageEditingCurrentRef) {
    const topLevel = selfRef.props.env ? selfRef.props.env.topLevel || selfRef.props.topLevel : selfRef.props.topLevel;
    const topLevelId = selfRef.props.env ? selfRef.props.env.topLevelId || selfRef.props.topLevelId : selfRef.props.topLevelId;
    const _page = topLevel ?? page;
    const _id = topLevel ? topLevelId : current?.id || selfRef.state?.current?.id;

    return {_page, _id};
}

/**
 * Mark this page as in editing (puts an ! on the icon for the page)
 *
 * @param {object} selfRef
 * @param {string} page
 * @param {object} [current] - optional state, if not using current for self
 */
export function startEditingPage(selfRef: PageEditingRef, page: string, current?: PageEditingCurrentRef) {
    const {_page, _id} = parse(selfRef, page, current);

    if (!store.getState().savedStatus.find(ss => (ss.page === _page) && (ss.id === _id))) {
        store.dispatch(startEditing(_page, _id));
    }
}

/**
 * Mark this page as in editing (puts an! on the icon for the page)
 *
 * @param {string} page
 * @param {string} id
 */
export function startEditingPageF(page: string, id: string) {
    if (!store.getState().savedStatus.find(ss => (ss.page === page) && (ss.id === id))) {
        store.dispatch(startEditing(page, id));
    }
}

/**
 * Unmark this page as in editing (puts an ! on the icon for the page)
 *
 * @param {any} selfRef
 * @param {string} page
 * @param {any} [current] - optional state, if not using current for self
 */
export function stopEditingPage(selfRef: PageEditingRef, page: string, current?: PageEditingCurrentRef) {
    const {_page, _id} = parse(selfRef, page, current);

    if (!!store.getState().savedStatus.find(ss => (ss.page === _page) && (ss.id === _id))) {
        store.dispatch(stopEditing(_page, _id));
    }
}

export function stopEditingPageF(page: string, id: string) {
    if (!!store.getState().savedStatus.find(ss => (ss.page === page) && (ss.id === id))) {
        store.dispatch(stopEditing(page, id));
    }
}